import { useEffect, useRef } from "react";
import { TrashWarningIcon } from "./icons";

export default function ConfirmDialog({
  open,
  title,
  detail,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}) {
  const ref = useRef(null);

  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (open && !dialog.open) {
      dialog.showModal();
    } else if (!open && dialog.open) {
      dialog.close();
    }
  }, [open]);

  return (
    <dialog
      ref={ref}
      className="confirm-dialog"
      onCancel={(e) => {
        e.preventDefault();
        onCancel?.();
      }}
      onClick={(e) => {
        if (e.target === ref.current) onCancel?.();
      }}
    >
      <div className="confirm-dialog__content">
        <div className="confirm-dialog__heading">
          <TrashWarningIcon className="confirm-dialog__icon" />
          <p className="confirm-dialog__title">{title}</p>
          {detail && <p className="confirm-dialog__detail">{detail}</p>}
        </div>
        <div className="confirm-dialog__actions">
          <button
            type="button"
            className="button button--danger button--full-width"
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
          <button
            type="button"
            className="button button--white button--full-width"
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
        </div>
      </div>
    </dialog>
  );
}
